import './styles.css'
import { Outlet } from 'react-router-dom'
import { OrderManagementContextProvider } from './context'

export const OrderManagement = () => {
  return (
    <OrderManagementContextProvider>
      <Outlet />
    </OrderManagementContextProvider>
  )
}
